<app-header></app-header>

<section id="equipo-int" class="bg-grey reset-section-pad2">

    <div class="container" data-aos="fade-right" data-aos-duration="1500">
          <div class="row" >
             <div class="col-lg-12 head-tit">
                   <h1 [innerHTML]="persona.name">
                    </h1>
                  <h2 [innerHTML]="persona.position"></h2>
             </div>   
         </div>

           <div class="row equipo-int-blq">

              <div class="col-lg-12 equipo-int-blq-inner-img">
                    <img class="img-fluid" [src]="img" alt="{{persona.imgBigAlt}}">
                    <div class="int-showcase__footer bg-grey"></div>
               </div>   
        
              <div class="col-lg-8 mt-5 equipo-int-blq-inner-text">
                   <p [innerHTML]="persona.description"></p>
               </div> 

                <div class="col-lg-12 equipo-int-blq-inner-social">
                    <p class="fw-bold">Sígueme en</p>
                      <a href="{{persona.linkedinUrl}}" target="_blank" rel="noreferrer noopener"><img class="rrss-equipo" src="assets/img/linkedin-icon.svg" width="30" alt="RRSS. Linkedin"></a>
               
               </div>  

         </div>

         <div class="row">

            <div class="col-lg-12 col-md-12 col-sm-12 col-12 prev-next">

               <div class="prev-next-blq">
               <!--activar clase inactiv cuando no haya ningún elemento más adelante o detrás-->
                <a 
                [ngClass]="{'inactiv': person == 0 || !persona.id_prev}"
                [routerLink]="person > 0 && persona.id_prev ? ['/equipo/', persona.id_prev] : null"
                ><span>Anterior</span>
                </a>
                <a
                [ngClass]="{'inactiv': !persona.id_next}"
                [routerLink]="persona.id_next ? ['/equipo/', persona.id_next]: null"
                ><span>Siguiente</span></a>

               </div> 


            </div>

         </div>



     </div><!-- fin container-->

</section>



<app-footer-main></app-footer-main>
